import { shiftParticipantActionMessageTypes } from '../../../../backend/extraTypes';
import { forEachEntityRow } from '@juvare/contact-management/backend/utils';
import { createShiftParticipantHistory } from './createShiftParticipantHistory';
import { getShiftParticipantStorage } from './getShiftParticipantStorage';
export function denyVolunteers(appContext, { data, filter, updateProcessedCount, updateTotalCount }) {
    const { status, shiftParticipations, shiftId } = data;
    forEachEntityRow(getShiftParticipantStorage(appContext), { filter }, (row, index) => {
        createShiftParticipantHistory(appContext, {
            participationId: row.id,
            participantId: row.columns.participantId,
            shiftId,
            status,
        });
        updateProcessedCount === null || updateProcessedCount === void 0 ? void 0 : updateProcessedCount(index + 1);
    }, updateTotalCount !== null && updateTotalCount !== void 0 ? updateTotalCount : (() => { }));
    const participantNotQualified = status === 'deniedNotQualified';
    const shiftParticipantActionSettingName = participantNotQualified ? 'denyParticipantNotQualified' : 'denyParticipantRosterFull';
    const messageType = participantNotQualified
        ? shiftParticipantActionMessageTypes.denyParticipantNotQualified
        : shiftParticipantActionMessageTypes.denyParticipantRosterFull;
    appContext.queues.enqueue(messageType, {
        shiftParticipationIds: shiftParticipations.map(({ participationId }) => participationId),
        shiftParticipantActionSettingName,
    });
}
